import React from "react";
import {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
} from "../Component/TableComponent/Table";
import InputSearch from "../Component/Search/Search";
import PickColumn from "../Component/PickColumn/PickColumn";
import Action from "../Component/Action/Action";
import AddGroup from "../Component/AddGroup/AddGroup";
import CreatedOn from "../Component/CreatedOn/CreatedOn";
import Filter from "../Component/Filter/Filter";
import { osplist } from "../Component/Utils/Utils";

function All_Products_Table() {
  const RowHeader = [
    "Product ID",
    "Status",
    "Product Name",
    "Product Categories",
    "Product HSN Code ",
    "Assigned to",
    "Tags",
    "Actions", 
    "Actions", 
  ];
const path="/admin-dashboard/save-product"
  return (
    <div>
      <Container>
        <Title>All Product List</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader  children={RowHeader} />
            <TableBody
              rows={osplist}
              // isLoading={isLoading}
              // error={error}
                path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}

export default All_Products_Table;
